import { render, staticRenderFns } from "./LoginVerification.vue?vue&type=template&id=65f6457b&scoped=true&"
import script from "./LoginVerification.vue?vue&type=script&lang=js&"
export * from "./LoginVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f6457b",
  null
  
)

export default component.exports